var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.333H2.5C2.15833 18.333 1.875 18.0497 1.875 17.708C1.875 17.3663 2.15833 17.083 2.5 17.083H17.5C17.8417 17.083 18.125 17.3663 18.125 17.708C18.125 18.0497 17.8417 18.333 17.5 18.333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.85 2.90005C14.2333 1.28338 12.65 1.24172 10.9917 2.90005L9.98333 3.90838C9.9 3.99172 9.86666 4.12505 9.9 4.24172C10.5333 6.45005 12.3 8.21672 14.5083 8.85005C14.5417 8.85838 14.575 8.86672 14.6083 8.86672C14.7 8.86672 14.7833 8.83338 14.85 8.76672L15.85 7.75838C16.675 6.94172 17.075 6.15005 17.075 5.35005C17.0833 4.52505 16.6833 3.72505 15.85 2.90005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0083 9.60866C12.7667 9.49199 12.5333 9.37533 12.3083 9.24199C12.125 9.13366 11.95 9.01699 11.775 8.89199C11.6333 8.80033 11.4667 8.66699 11.3083 8.53366C11.2917 8.52533 11.2333 8.47533 11.1667 8.40866C10.8917 8.17533 10.5833 7.87533 10.3083 7.54199C10.2833 7.52533 10.2417 7.46699 10.1833 7.39199C10.1 7.29199 9.95833 7.12532 9.83333 6.93366C9.73333 6.80866 9.61666 6.62533 9.50833 6.44199C9.375 6.21699 9.25833 5.99199 9.14166 5.75866C8.9887 5.43088 8.55849 5.3335 8.30271 5.58928L3.61666 10.2753C3.50833 10.3837 3.40833 10.592 3.38333 10.7337L2.93333 13.9253C2.85 14.492 3.00833 15.0253 3.35833 15.3837C3.65833 15.6753 4.075 15.8337 4.525 15.8337C4.625 15.8337 4.725 15.8253 4.825 15.8087L8.025 15.3587C8.175 15.3337 8.38333 15.2337 8.48333 15.1253L13.1771 10.4315C13.4278 10.1809 13.3336 9.7496 13.0083 9.60866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.37ed1c9ab2507883fd7c5c5b1660ffd0.svg";
export { ForwardRef as ReactComponent };